import React from 'react';
import styled from 'styled-components';
import { Dialog, ElevatedButton } from '@producer/ui-kit';

type ChangePlanModalProps = {
  title: string;
  description: string;
  onCancel: () => void;
};

export const ChangePlanModal: React.FC<ChangePlanModalProps> = ({
  title,
  description,
  onCancel,
}) => {
  return (
    <Dialog
      title={title}
      onClose={onCancel}
      actions={[<ElevatedButton key="close" text="Close" onClick={onCancel} />]}
    >
      <Container
        dangerouslySetInnerHTML={{
          __html: description,
        }}
      />
    </Dialog>
  );
};

const Container = styled.p`
  line-height: 2.4rem;
  color: var(--color-grayscale-light-slate);

  a {
    color: white;
    text-decoration: underline;
  }
`;
